import { useMemo } from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import styles from "./EnumMultiselectFilter.module.scss";

interface Props<T extends string> {
    values: readonly T[];
    labels: Record<T, string>;
    value: T[] | undefined;
    name: string;
    onChange: (value: T[] | undefined) => void;
}

export const EnumMultiselectFilter = <T extends string>({
    values,
    labels,
    value,
    name,
    onChange,
}: Props<T>) => {
    const options = useMemo(
        (): Array<FilterMultiselectOption<T>> =>
            values.map((item) => ({
                value: item,
                label: labels[item],
                searchableLabel: labels[item],
            })),
        [values, labels],
    );

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value ?? []}
                onChange={(selected) =>
                    onChange(selected.length > 0 ? selected : undefined)
                }
                name={name}
                onBlur={noop}
            />
        </div>
    );
};
